<template>
  <label>
    <input :name="name" :id="id"
           :checked="value"
           type="checkbox"
           @change="change"
    >
    <span class="check"></span>
    <b>{{label}}</b>
  </label>
</template>

<script>
  import { randomString } from '../../utils/string'

  export default {
    name: 'checkbox-input',
    props: {
      name: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'text'
      },
      id: {
        type: String,
        default: () => {
          return randomString()
        }
      },
      required: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      value: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      change ($event) {
        this.$emit('input', $event.target.checked)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/form/CheckBoxInput.vue